import addError from '../../../utils/error.jsx';

export function request(sportId, market) {
    return {
        type: 'MARKET_TEMPLATES_CREATION_REQUEST',
        sportId,
        market
    };
}

export function error(sportId, errors) {
    addError(errors);

    return {
        type: 'MARKET_TEMPLATES_CREATION_ERROR',
        sportId,
        errors
    };
}

export function finish(sportId, market) {
    return {
        type: 'MARKET_TEMPLATES_CREATION_FINISH',
        sportId,
        market
    };
}
